<template>
  <span class="plate-number-input" >
    <div @click.stop="showKeyBoard=true" class="plate-number-cell" >
      <div class="plate-input-wrapper">
        <div :class="{'cursor-text': showKeyBoard, 'field-error': error }"  style="white-space:nowrap">{{value}}</div>
      </div>
      <a class="clear-btn" @click="clear()" v-show="value"><van-icon name="clear" color="gray" /></a>
      <van-tag :color="plateNumberType.color" style="white-space:nowrap" v-show="plateNumberType.name" plain>{{plateNumberType.name}}</van-tag>
    </div>
    <div v-show="showKeyBoard" :class="{'plate-number-input-pannel': true, 'iphone-black-botton': isIPhoneBlackBotton}"  @click.stop="showKeyBoard=true">
      <div v-for="(line, i) in boardKeys" :key="i" class="key-line">
        <button v-show="isKeyShow(key)" type="button" :disabled="isKeyDisable(key)" v-for="(key, j) in line" :key="j" :class="{'key': true, 'big-key': isBigKey(key)}" @click="onClick(key)">
          <img v-if="key==='del'" src="../assets/icon_keyboard_del.png">
          <span v-else>{{key}}</span>
        </button>
      </div>
    </div>
  </span>
</template>

<script>
import { Field, Icon, Tag } from 'vant'

const firstBoardKeys = [
  ['粤','京','津','冀','晋','蒙','辽','吉','黑'],
  ['沪','苏','浙','皖','闽','赣','鲁','豫','鄂'],
  ['湘','桂','琼','川','贵','云','渝','藏'],
  ['陕','甘','青','宁','新','使']
];

const secondBoardKeys = [
  ['1','2','3','4','5','6','7','8','9','0'],
  ['Q','W','E','R','T','Y','U','港','O','澳','P'],
  ['A','S','D','F','G','H','J','K','L'],
  ['领','Z','X','C','V','B','N','M','警','del']
]

// value是length,表示每个键在length是几时将被禁用
const disableKeys = {
  '2': [1],
  '3': [1],
  '4': [1],
  '5': [1],
  '6': [1],
  '7': [1],
  '8': [1],
  '9': [1],
  '0': [1],
  '港': [1, 2, 3, 4, 5, 7, 8],
  '澳': [1, 2, 3, 4, 5, 7, 8],
  '警': [1, 2, 3, 4, 5, 7, 8],
  '领': [1, 2, 3, 4, 5, 7, 8]
}

// value是length, 表示每个键在length是几时被隐藏
const hiddenKeys = {
  '澳': [1],
  'O': [2, 3, 4, 5, 6, 7, 8]
}

export default {
  name: 'PlateNumberInput',
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: String,
    error: Boolean,
    focus: Boolean
  },
  data() {
    return {
      showKeyBoard: !!this.focus
    }
  },
  components: {
    [Field.name] : Field,
    [Icon.name] : Icon,
    [Tag.name] : Tag
  },
  methods: {
    isBigKey(key) {
      return this.length < 1 || key.length != 1 || !/[0-9A-Z]/.test(key) || key === 'O';
    },
    onClick(key) {
      let v = this.value || "";
      if (key === 'del' && v.length > 0) {
        v = v.substr(0, v.length-1);
      } else if (key != 'del' && v.length < 8) {
        v += key;
      }
      this.$emit('input', v);
    },
    onDocumentClick() {
      this.showKeyBoard = false;
    },
    isKeyDisable(key) {
      const positions = disableKeys[key];
      return (this.length > 7 && key != 'del') || (positions && positions.includes(this.length));
    },
    isKeyShow(key) {
      const positions = hiddenKeys[key];
     
      return !positions || !positions.includes(this.length)
    },
    clear() {
      this.$emit('input', '');
    }
  },
  watch: {
    showKeyBoard: function(n, o) {
      if (!n && o) {
        this.$emit('change', this.value);
      }
    }
  },
  created() {
    document.addEventListener('click', this.onDocumentClick);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.onDocumentClick);
  },
  computed:  {
    boardKeys() {
      if (this.length < 1 ) {
        return firstBoardKeys;
      }
      return secondBoardKeys;
    },
    isIPhoneBlackBotton() {
      if (typeof window !== 'undefined' && window) {
          return /iphone/gi.test(window.navigator.userAgent) && window.screen.height >= 812;
      }
      return false;
    },
    length() {
      return this.value ? this.value.length : 0;
    }, 
    plateNumberType() {
      if (this.length < 7) {
        return {};
      }
      else if (this.length > 7) {
        return {name: '新能源', color: 'green'}
      } else if (this.value.includes('警')) {
        return {name: '警车牌', color: 'red'}
      } else if (this.value.includes('港') || this.value.includes('澳')) {
        return {name: '港澳牌', color: 'black'}
      } else if (this.value.includes('使') || this.value.includes('领')) {
        return {name: '使领馆', color: 'black'}
      }
      return {name: '普通牌', color: ' #0090fa'}
    }
  }
}
</script>
<style lang="less" scoped>
.plate-number-input .van-cell{
  padding: 0;
}
.plate-number-input .van-cell:not(:last-child)::after {
  border-bottom: 0;
}


.plate-number-input-pannel{
  user-select: none;
  background-color: #CFD5DB;
  margin: 0;
  padding-top: 4px;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  animation:0.3s ease-out 0s popkeyboard;
  text-align: center;
  z-index: 200;
  border-top: 1px solid #ccc;
  overflow: hidden;

  .key-line{display: flex;flex-direction: row;justify-content:center;max-width: 500px;margin: 0 auto}
  .key{font-size: 22px;display: inline-block;width: 8.6%; height: 44px;border-radius: 5px; background-color: white; margin: 4px 2px; padding: 8px 0; box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.4);color: #030303;line-height: 24px;border:none;}
  .key.img-key{width: 11.5%;background-color: #A9B4BC}
  .key:visited{color: #030303}
  .key:focus {outline:0;}
  .big-key{width: 9.5%}
  .key[disabled] { background-color: #dedede; color: #999;}
  .key img{height: 18px;vertical-align: middle;display: inline-block;margin-top: -5px;}
}
.iphone-black-botton {
  padding-bottom: 24px;
}
.field-error {
  color: red;
}
@keyframes popkeyboard{ from { transform: translate(0, 240px);opacity: 0} to {opacity: 1}  }
.cursor-text:after{content: '|';font-weight: bold;line-height: 1em;font-size: 1.4em;animation:0.5s ease-in-out 0s infinite alternate twinkle;}
@keyframes twinkle { from { color: white} to { color: #1c76d8}  }
.plate-number-cell {
  display: flex;
  height: 16px;
  align-items: center; 
}
.plate-input-wrapper {
  display: inline-block;
  width: 8em;
}
.clear-btn {
  display: inline-block;
  padding: 5px 10px;
}
</style>